<template>
  <ul :class="$style.container">
    <li
      v-for="item in list(this)"
      :key="item.name"
      :class="[$style.item, { [$style.itemDisabled]: item.disabled }]"
      @click="item.handler"
    >
      <BaseIcon :name="item.icon" :class="$style.icon" />
      <div>{{ item.name }}</div>
    </li>
    <li>
      <div :class="$style.filters" v-if="filters">
        <div :class="[$style['filters-top'], { [$style.open]: showFilters }]" @click="showFilters = !showFilters">
          <div>Add to filter</div>
          <svg fill="currentColor" height="8" viewBox="0 0 12 8" width="12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.292969 1.70712L1.70718 0.292908L6.00008 4.5858L10.293 0.292908L11.7072 1.70712L6.00008 7.41423L0.292969 1.70712Z"
            />
          </svg>
        </div>
        <div :class="$style['filters-body']" v-show="showFilters">
          <ul :class="$style['filters-list']">
            <li @click="removeChatFromFilter()" v-close-popover v-show="activeFilterId !== 'all'">
              {{ $t('tabAllChats') }}
            </li>
            <li
              v-for="filter in filters"
              :key="filter.id"
              :class="{ [$style.active]: activeFilterId === filter.id && currentFilterChat }"
              @click="addChatToFilter(filter)"
              v-close-popover
            >
              {{ filter.name }}
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { parseRouterQueryParam } from '@/helpers/index'

export default {
  name: 'chat-menu',
  props: {
    chat: {
      type: Object,
      required: true
    },
    provider: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      showFilters: false
    }
  },
  computed: {
    ...mapGetters({
      filters: 'filter/filters',
      currentFilterChats: 'filter/currentChats'
    }),
    activeChatId () {
      return parseRouterQueryParam(this.$route.query.id, true)
    },
    activeFilterId () {
      return parseRouterQueryParam(this.$route.query.filter) || 'all'
    },
    currentFilterChat () {
      // eslint-disable-next-line eqeqeq
      return this.currentFilterChats.find(e => e.chatId == this.activeChatId)
    }
  },
  methods: {
    ...mapActions({
      addToFilter: 'filter/addChatToFilter',
      getFilterChats: 'filter/getFilterChats',
      deleteChatFromFilter: 'filter/deleteChatFromFilter'
    }),
    removeChatFromFilter () {
      const item = this.currentFilterChat
      if (item) this.deleteChatFromFilter(item)
    },
    list () {
      const handleShowDeletePopup = () => {
        if (this.provider === 'matrix') {
          this.$modal.show('delete-chat-matrix')
        } else {
          this.$modal.show('delete-chat')
        }
      }
      return [
        // {
        //   name: 'Edit chat name',
        //   icon: 'pencil-alt',
        //   disabled: true,
        //   handler: () => {
        //     this.$modal.show('edit-group')
        //   }
        // },
        {
          name: this.$t('chat.delete'),
          icon: 'trash-alt',
          handler: handleShowDeletePopup
        }
      ]
    },
    async addChatToFilter (filter) {
      await this.addToFilter({
        chatId: this.activeChatId.toString(),
        chatFilterId: filter.id
      })
      const id = this.activeFilterId
      if (id && id !== 'invites') {
        await this.getFilterChats()
      }
    }
  }
}
</script>

<style lang="scss" module>
.filters {
  &-list {
    max-height: 250px;
    overflow-y: auto;
    li {
      cursor: pointer;
      &.active {
        color: $green;
        font-weight: 500;
        cursor: none;
        pointer-events: none;
      }
    }
  }
  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    user-select: none;
    color: $text-darkest;
    &:hover {
      background: rgba($green, 0.1);
    }
    &.open {
      background: rgba($green, 0.3);
      svg {
        transform: rotateX(180deg);
      }
    }
  }
  &-body {
    li {
      padding: 8px 12px 8px 20px;
      &:hover {
        background: rgba($green, 0.1);
      }
    }
  }
}
.container {
  width: 100%;
  color: $text-darkest;
  padding: 6px 0 6px 0;
}
.item {
  height: 42px;
  display: flex;
  font-size: 14px;
  align-items: center;
  cursor: pointer;
  padding-right: 12px;
  &Disabled {
    color: $text-mid;
    cursor: default;
  }
  &:not(.itemDisabled):hover {
    color: $text-colored;
    .icon {
      color: $text-colored;
    }
  }
}
.icon {
  margin: 0 12px;
  color: $text-light;
  font-size: 16px;
}
</style>
